import { combineReducers } from "redux";
import { configureStore, Action, ThunkAction } from "@reduxjs/toolkit";
import { includes } from "lodash";

import config from "../config";
import { useSelector, TypedUseSelectorHook } from "react-redux";
import { dummySlice, authSlice, configurationSlice, screenSlice, orderSlice } from ".";

const rootReducer = combineReducers({
    dummy: dummySlice.reducer,
    auth: authSlice.reducer,
    configuration: configurationSlice.reducer,
    screen: screenSlice.reducer,
    orders: orderSlice.reducer,
});
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createStore = () =>
    configureStore({
        reducer: rootReducer,
        devTools: includes(["Local", "Review", "Staging"], config.environment),
    });

export const store = createStore();
export type RootDispatch = typeof store.dispatch;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
